"use strict";
import { useCallback, useEffect, useRef } from "react";
export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
export function useMemoCompare(next, compare) {
  const previousRef = useRef();
  const previous = previousRef.current;
  const nextValue = next();
  const isEqual = compare(previous, nextValue);
  if (!isEqual || !previous) {
    previousRef.current = nextValue;
  }
  return isEqual && previous ? previous : nextValue;
}
export function useOnClickOutside(node, handler, ignoredNodes = []) {
  const handlerRef = useRef(handler);
  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);
  useEffect(() => {
    const handleClickOutside = (e) => {
      const nodeClicked = node.current?.contains(e.target);
      const ignoredNodeClicked = ignoredNodes.reduce(
        (reducer, val) => reducer || !!val.current?.contains(e.target),
        false
      );
      if ((nodeClicked || ignoredNodeClicked) ?? false) {
        return;
      }
      if (handlerRef.current) {
        handlerRef.current();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [node, ignoredNodes]);
}
export function useEvent(callback) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  return useCallback((...args) => callbackRef.current(...args), []);
}
